import type { FC } from 'react';
import styled from 'styled-components';
import { getHSLGradient } from './getHSLGradient';
import { GradientContainer } from './GradientContainer';

export const StaticGradientBar: FC = () => {
  const gradient = getHSLGradient(0, 120, 120);

  return <Container gradient={gradient}/>
};

const Container = styled(GradientContainer)<{ gradient: string }>`
  background: ${(props): string => props.gradient};
`;
